import { extendTheme } from "@chakra-ui/react";
import OpenColor from "open-color";

const FONT_FAMILY =
  '"Karla", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto","Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue"';

const FONT_CODE = '"Inconsolata", monospace';
const theme = extendTheme({
  fonts: {
    body: FONT_FAMILY,
    heading: FONT_FAMILY,
  },
  fontWeight: {
    heading: 700,
    text: 400,
  },
  colors: {
    gray: {
      50: OpenColor.gray[0],
      100: OpenColor.gray[1],
      200: OpenColor.gray[2],
      300: OpenColor.gray[3],
      400: OpenColor.gray[4],
      500: OpenColor.gray[5],
      600: OpenColor.gray[6],
      700: OpenColor.gray[7],
      800: OpenColor.gray[8],
      900: OpenColor.gray[9],
    },
  },
  components: {
    Text: {
      variants: {
        code: {
          fontFamily: FONT_CODE,
          fontWeight: 700,
          backgroundColor: OpenColor.indigo[1],
          whiteSpace: "nowrap",
          px: "2",
        },
        bold: {
          fontWeight: 600,
        },
        link: {
          textDecoration: "underline",
        },
      },
    },
  },
});

export default theme;
